export enum SecuritiesRoutes {
  CreateOne = 'create-one',
  Search = 'search',
  UpdateOne = 'update-one',
}
